module.exports = __webpack_public_path__ + "img/user-group_zh.07aba5e8.png";